import React from 'react';
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Tabla from '../Tabla';
import MatchList from '../MatchList';
import MatchCardGroup from '../MatchCardGroup';
import Players from '../Players';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
class Campeonato2019 extends React.Component {

  constructor(props){
    super(props);
        this.comeBack = this.comeBack.bind(this);
	this.handleChange = this.handleChange.bind(this);
	var id_list = [];
	for (var i = 73; i <= 93; i++) {
        	id_list.push(i);
        }
    this.state = {
	showCards: true,
      path: this.props.path,
	kits:[],
        kit_path: '/images_fem/kits/todas/',
      ctype: this.props.ctype,
      torneo: this.props.torneo,
      id_list: id_list,
      table1:[{'color':0,'shortname':'udeconce', 'rivalName':'U. de Concepción', 'pj':21, 'pg':6,'pe':2,'pp':13,'gf':36,'gc':72,'dif':-36, 'pts':20},
	      {'color':'#E42727','shortname':'cobresal', 'rivalName':'Cobresal', 'pj':21, 'pg':0,'pe':0,'pp':21,'gf':13,'gc':148,'dif':-135, 'pts':0},
	      {'color':0,'shortname':'audax', 'rivalName':'A. Italiano', 'pj':21, 'pg':7,'pe':4,'pp':10,'gf':36,'gc':34,'dif':2, 'pts':25},
	      {'color':0,'shortname':'wanderers', 'rivalName':'S. Wanderers', 'pj':21, 'pg':5,'pe':0,'pp':16,'gf':33,'gc':71,'dif':-38, 'pts':15},
	      {'color':0,'shortname':'catolica', 'rivalName':'U. Católica', 'pj':21, 'pg':6,'pe':6,'pp':9,'gf':28,'gc':34,'dif':-6, 'pts':24},
	      {'color':0,'shortname':'vial', 'rivalName':'Fernández Vial', 'pj':22, 'pg':8,'pe':2,'pp':12,'gf':41,'gc':47,'dif':-6, 'pts':26},
	      {'color':0,'shortname':'temuco', 'rivalName':'Dep. Temuco', 'pj':22, 'pg':8,'pe':4,'pp':10,'gf':48,'gc':53,'dif':-5, 'pts':28},
	      {'color':0,'shortname':'everton', 'rivalName':'Everton', 'pj':21, 'pg':9,'pe':5,'pp':7,'gf':45,'gc':34,'dif':11, 'pts':32},
	      {'color':'#295e1e','shortname':'colocolo', 'rivalName':'Colo Colo', 'pj':20, 'pg':18,'pe':1,'pp':1,'gf':86,'gc':11,'dif':75, 'pts':55},
	      {'color':0,'shortname':'udechile', 'rivalName':'U. de Chile', 'pj':20, 'pg':8,'pe':5,'pp':7,'gf':51,'gc':34,'dif':17, 'pts':29},
	      {'color':'#295e1e','shortname':'palestino', 'rivalName':'Palestino', 'pj':21, 'pg':17,'pe':1,'pp':3,'gf':80,'gc':24,'dif':56, 'pts':52},
	      {'color':'#295e1e','shortname':'morning', 'rivalName':'S. Morning', 'pj':21, 'pg':19,'pe':2,'pp':0,'gf':99,'gc':11,'dif':88, 'pts':59},
	      {'color':0,'shortname':'iquique', 'rivalName':'Dep. Iquique', 'pj':21, 'pg':6,'pe':2,'pp':13,'gf':43,'gc':63,'dif':-20, 'pts':20},
	      {'color':'#295e1e','shortname':'antofagasta', 'rivalName':'Antofagasta', 'pj':21, 'pg':11,'pe':4,'pp':6,'gf':48,'gc':50,'dif':-2, 'pts':37}]
    };
  }

  componentDidMount() {
	this.getKits();
		let newtable = this.sortTable(this.state.table1);
  		this.setState({table1:newtable});
	}

 getKits(){

        fetch("https://www.registrosudec.com:5000/kits_femenino", {

    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id_list: this.state.id_list
    })
    }).then(
                res => res.json()
                )
  .then(
    (result) => {
        console.log(result)
        this.setState({ 
        kits: result['kits']}) //[{path:"45.png", kit:yellow, short:"blue", socks:"blue", count:15, 
    },
    // Nota: es importante manejar errores aqu   y no en
    // un bloque catch() para que no interceptemos errores
    // de errores reales en los componentes.
    (error) => {
      console.log(error);
      this.setState({fecha: []})
    }
  );
}



  handleChange(val){
    console.log(val);
    if(val===1){
      this.setState({showCards:true});
    }
    else{
      this.setState({showCards:false});
    }
  }

comeBack(){
this.setState({path:this.state.path});
}

subText(color, text){

let comp = [];
comp.push(

	<Row className="justify-content-md-center">
            <Col lg={2} xl={2} >

        <Table bordered={ false } size="sm">
        <tr style={{border: 'none', textAlign: 'rigth' }}>
        <td bgcolor={color}>
        </td>
        <td style={{border: 'none', textAlign: 'center'}}> {text} </td>
        </tr>
        </Table>
        </Col>
        </Row>



)
return comp;

}


sortTable(table){
       let aux;
      for(let i=table.length-1;i>0;i--){
             for(let j =0; j<i; j++){
                 if( (table[j].pts < table[j+1].pts) || 
                     ((table[j].pts === table[j+1].pts) && (table[j].dif < table[j+1].dif)) ||
                     ((table[j].pts === table[j+1].pts) && (table[j].dif === table[j+1].dif) && (table[j].gf < table[j+1].gf))){
			aux = table[j+1];
			table[j+1] = table[j];
                        table[j] = aux;
		} 
	     }		
	}
return table;

}


render(){

  let subD = this.subText('#E42727', 'Desciende a Primera B');
  let subT = this.subText('#295e1e', 'Clasificado a Play-Off');
  return(

	<div style={{textAlign: 'center' }}>
	      <div style={{ height: '50px' }}></div>
        <div className="mytitlepartidos">  Indumentaria UDEC Campeonato 2019</div>
        <div style={{ height: '50px' }}></div> 

        <div style={{display: 'inline-block' }}>
        <table style={{textAlign: 'center' }}>
        <tr>
           {this.state.kits.map((i) => {
                   return ( <td> <Image  className="escudo-home" src={this.state.kit_path+i['path']+".png"}/> </td>)
            })}
        </tr>
        <tr>
        {this.state.kits.map((i) => {
                   return ( <td> <Image  className="myshort" src={this.state.kit_path+i['short']+".png"}/> </td>)
            })}
        </tr>
        <tr>
        {this.state.kits.map((i) => {
                   return ( <td> <Image  className="myshort" src={this.state.kit_path+'socks-'+i['socks']+".png"}/> </td>)
            })}
        </tr>

        <tr>
                {this.state.kits.map((i) => {
                   return ( <td class="circle"> {i['count']} </td>)
            })}
        </tr>
        </table>
        </div>

      <div style={{ height: '50px' }}></div>
	<div style={{ height: '10px' }}></div>
	{<Tabla teams={this.state.table1} />}
        <div style={{ height: '10px' }}></div>
        *El campeonato fue suspendido en la fecha 21 anulando los descensos. 
        <div style={{ height: '2px' }}></div>
        No se logró jugar los partidos contra
U. de Chile (L), Vial (V), Palestino (L), Cobresal (V), S. Wanderers (L).
        <div style={{ height: '10px' }}></div>


         {subT}
	 {subD}


	<div style={{ height: '100px' }}></div>
	<div className="mytitlepartidos">  Partidos UDEC Campeonato 2019</div>
	<div style={{ height: '10px' }}></div>

	<ToggleButtonGroup type="radio" name="options" defaultValue={1} onChange={this.handleChange}>
            <ToggleButton variant="secondary" value={1}>Tarjetas</ToggleButton>
            <ToggleButton variant="secondary" value={2}>Listado</ToggleButton>
          </ToggleButtonGroup>
	 <div style={{ height: '10px' }}></div>
	<Container>
	<div className={this.state.showCards ? '': 'hiddenCard'}>
           <MatchCardGroup id_list={this.state.id_list}></MatchCardGroup>
         </div>
         <div className={this.state.showCards ? 'hiddenCard': ''}>

           <MatchList id_list={this.state.id_list} showName={true}></MatchList>

         </div>
	</Container>

	<div style={{ height: '100px' }}></div>
        <div className="mytitlepartidos">  Jugadores UDEC Campeonato 2019 </div>
        <div style={{ height: '10px' }}></div>

	<Players torneo="Campeonato 2019" />
     </div>


  )
}

}
export default Campeonato2019;
